// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { IndustrialPremises } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetIndustrialPremises = (
  options: useGetGenericInstanceProps<IndustrialPremises>
) => {
  return useGetInstance<IndustrialPremises>({
    ...options,
    modelName: 'industrialpremises'
  });
};

export const useGetIndustrialPremisesList = (
  options: useGetGenericListProps<IndustrialPremises>
) => {
  return useGetList<IndustrialPremises>({
    ...options,
    modelName: 'industrialpremises'
  });
};
